<article class="wishlist-card" (click)="navigateToViewProduct(data?.productId?._id)">
  <div class="wishlist-card__media">
    <img
      class="wishlist-card__image"
      [src]="data?.productId?.thumbnail"
      [hidden]="!isLoaded"
      (load)="onImageLoad()"
      [alt]="data?.productId?.productName || 'Wishlist product'"
    />
    <ngx-skeleton-loader *ngIf="!isLoaded" [theme]="theme" count="1"></ngx-skeleton-loader>
  </div>

  <div class="wishlist-card__body">
    <p class="wishlist-card__title">
      {{ data?.productId?.productName }}
    </p>

    <p class="wishlist-card__price" *ngIf="data?.productId?.priceSizeDetails">
      {{
        getPrice(
          data?.productId?.priceSizeDetails[0]?.price
            | currency : 'ZAR' : 'R'
        )
      }}
    </p>
  </div>
</article>